var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid modal-comment__container" }, [
      _c(
        "div",
        {
          staticClass:
            "grid__col--2 modal-comment__icon-container h-center-align"
        },
        [
          _c("div", {
            staticClass:
              "modal-comment--blank modal-comment__icon modal-comment__icon--blank"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid__col--10 h-no-padding modal-comment__text-container"
        },
        [
          _c("div", {
            staticClass:
              "modal-comment__author modal-comment__author--blank modal-comment--blank"
          }),
          _vm._v(" "),
          _c("div", {
            staticClass:
              "modal-comment__datetime modal-comment__datetime--blank modal-comment--blank"
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "modal-comment__content modal-comment__content--blank"
            },
            [
              _c("div", {
                staticClass: "modal-comment__text-line modal-comment--blank"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "modal-comment__text-line modal-comment--blank"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "modal-comment__text-line modal-comment--blank"
              })
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }